// src/App.tsx
import React, { useState } from "react";
import { Provider } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { enUS } from "date-fns/locale";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import store from "./redux/store";
import LoginPage from "./pages/LoginPage";
import NotificationForm from "./pages/NotificationPage";
import Dashboard from "./pages/DashboardPage";
import CreateUserPage from "./pages/CreateUserPage";
import ProductPage from "./pages/ProductPage";
import SupportPage from "./pages/SupportPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import TermsAndConditions from "./pages/TermsAndConditionsPage";
import CreateUserRolePage from "./pages/CreateUserRolePage";
import ManageUserRolePage from "./pages/ManageUserRolePage";
import EditUserRolePage from "./pages/EditUserRolePage";
import ViewUserPage from "./pages/ViewUserPage";
import ViewProductPage from "./pages/ViewProductPage";
import AuditTrailPage from "./pages/AuditTrailPage";
import IdleTimePage from "./pages/IdleTimePage";
import PaynamicsSuccessPage from "./pages/Paynamics Placeholder/SuccesPage";
import PaynamicsFailedPage from "./pages/Paynamics Placeholder/FailPage";
import PaynamicsSuccessPageRenewal from "./pages/Paynamics Placeholder/SuccessPageRenewal";
import PaynamicsSuccessPagePremium from "./pages/Paynamics Placeholder/SuccessPagePremium";
import VersionManager from "./pages/MobileAppVersionPage";
import ViewBatchNotificationPage from "./pages/ViewBatchNotificationPage";

function App() {
  let elapsedTime = 0;

  const [sessionTimeout, setSessionTimeout] = useState<number>(
    Number(localStorage.getItem("sessionTimeout") ?? 3) * 60
  );

  window.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      elapsedTime = 0;
    }
  });

  document.addEventListener("click", function () {
    elapsedTime = 0;
  });
  document.addEventListener("mousemove", function () {
    elapsedTime = 0;
  });
  document.addEventListener("scroll", function () {
    elapsedTime = 0;
  });
  document.addEventListener("keydown", function () {
    elapsedTime = 0;
  });

  window.addEventListener("storage", () => {
    const value = Number(localStorage.getItem("sessionTimeout") ?? 0) * 60;

    if (value !== 0 && sessionTimeout !== value) {
      setSessionTimeout(value);
    }
  });

  const frequency = setInterval(function () {
    elapsedTime += 1;
    if (elapsedTime >= sessionTimeout) {
      clearInterval(frequency);
      localStorage.setItem("userTimeOut", "true");
    } else {
      localStorage.setItem("userTimeOut", "false");
    }
  }, 5000);

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/notification" element={<NotificationForm />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-user" element={<CreateUserPage />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/view-product" element={<ViewProductPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/help-center" element={<HelpCenterPage />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/create-user-role" element={<CreateUserRolePage />} />
            <Route path="/manage-user-role" element={<ManageUserRolePage />} />
            <Route path="/edit-user-role" element={<EditUserRolePage />} />
            <Route path="/view-user" element={<ViewUserPage />} />
            <Route path="/audit-trail" element={<AuditTrailPage />} />
            <Route path="/idle-time" element={<IdleTimePage />} />
            <Route path="/app-updates" element={<VersionManager />} />
            <Route
              path="/notification-view-batch"
              element={<ViewBatchNotificationPage />}
            />

            {/* Default Route */}
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Paynamics Route */}
            <Route
              path="/paynamics_pending"
              element={<PaynamicsSuccessPage />}
            />
            <Route
              path="/paynamics_cancelled"
              element={<PaynamicsFailedPage />}
            />
            <Route
              path="/paynamics_pending_policy"
              element={<PaynamicsSuccessPageRenewal />}
            />
            <Route
              path="/paynamics_pending_premium"
              element={<PaynamicsSuccessPagePremium />}
            />
          </Routes>
        </Router>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
